module.exports = __webpack_public_path__ + "static/media/dc-electric-arc-furnace.fda0c4dd.png";